var Summary = require('../summary');
function summaryBucketKey() {
  var nft_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var price = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return "".concat(nft_id, ":").concat(Number(price));
}
function escapeAttr() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
}
function cssEscape() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
    return CSS.escape(String(value));
  }
  return String(value).replace(/[^a-zA-Z0-9_-]/g, function (ch) {
    return "\\".concat(ch);
  });
}

/**
 * Listing identity for teaser DOM targeting.
 * Prefer listing_signature; fall back to nft_id:price bucket.
 * Returns the data-attribute name/value used on each `.teaser` instance.
 */
function listingTeaserIdentity(summary) {
  if (summary !== null && summary !== void 0 && summary.listing_signature) {
    return {
      attr: 'data-listing-signature',
      value: String(summary.listing_signature)
    };
  }
  return {
    attr: 'data-listing-bucket',
    value: summaryBucketKey(summary === null || summary === void 0 ? void 0 : summary.nft_id, summary === null || summary === void 0 ? void 0 : summary.price)
  };
}

/** HTML attribute fragment for a teaser root element (no id). */
function listingTeaserDataAttrs(summary) {
  var _listingTeaserIdentit = listingTeaserIdentity(summary),
    attr = _listingTeaserIdentit.attr,
    value = _listingTeaserIdentit.value;
  if (!value) {
    return '';
  }
  return "".concat(attr, "=\"").concat(escapeAttr(value), "\"");
}

/** CSS selector matching all teaser instances for this listing. */
function listingTeaserSelector(summary) {
  var _listingTeaserIdentit2 = listingTeaserIdentity(summary),
    attr = _listingTeaserIdentit2.attr,
    value = _listingTeaserIdentit2.value;
  if (!value) {
    return '';
  }
  return ".teaser[".concat(attr, "=\"").concat(cssEscape(value), "\"]");
}
function syncSummaryCache(mod, data) {
  var summary = data instanceof Summary ? data : new Summary(mod.app, mod, data);
  if (!summary.nft_id) {
    return null;
  }
  var key = summaryBucketKey(summary.nft_id, summary.price);
  mod.summaries[key] = summary;
  return summary;
}
module.exports = {
  summaryBucketKey: summaryBucketKey,
  listingTeaserIdentity: listingTeaserIdentity,
  listingTeaserDataAttrs: listingTeaserDataAttrs,
  listingTeaserSelector: listingTeaserSelector,
  syncSummaryCache: syncSummaryCache
};